import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewGroup = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6189 14.1333C15.0356 14.1333 16.1841 12.9842 16.1841 11.5667C16.1841 10.1491 15.0356 9 13.6189 9C12.2021 9 11.0536 10.1491 11.0536 11.5667C11.0536 12.9842 12.2021 14.1333 13.6189 14.1333Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 18.185C11.9973 16.1866 15.2405 16.1866 17.2469 18.185",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6189 26.9392C15.0356 26.9392 16.1841 25.79 16.1841 24.3725C16.1841 22.955 15.0356 21.8058 13.6189 21.8058C12.2021 21.8058 11.0536 22.955 11.0536 24.3725C11.0536 25.79 12.2021 26.9392 13.6189 26.9392Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 31C11.9973 29.0016 15.2405 29.0016 17.2469 31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3811 26.9392C27.7979 26.9392 28.9464 25.79 28.9464 24.3725C28.9464 22.955 27.7979 21.8058 26.3811 21.8058C24.9644 21.8058 23.8159 22.955 23.8159 24.3725C23.8159 25.79 24.9644 26.9392 26.3811 26.9392Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7531 31C24.7503 29.0016 27.9935 29.0016 30 31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 9V17",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 13H30",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgNewGroup);
export default ForwardRef;
